import React from "react";
import { Grid } from "@mui/material";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import "../assets/styles/projects.css";
import image1 from "../assets/image/ec-commerce.jpg";
import image2 from "../assets/image/chatAppUI.png";
import image3 from "../assets/image/motorCycle.jpg";
import image4 from "../assets/image/tour.png";
import etickets from "../assets/image/etickets.png";
import Carousel from "better-react-carousel";
import Tooltip from "@mui/material/Tooltip";
import ProjectModal from "./ProjectModal";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

const projects = [
  {
    id: 1,
    name: "etickets bd",

    img: etickets,
    live: "https://etickets-bd.vercel.app/",
    repo: "https://github.com/MuhammadJunaid01/ar-poribohon",
    info: " My website showcases my extensive resume and portfolio, highlighting my proficiency in Next.js with TypeScript and the latest Next.js version 13 app router. As a developer, I have undertaken a significant project called 'Bus Poribohon.' This project offers a seamless and efficient bus ticketing system for users, covering 32 bus routes. To ensure the utmost security and privacy, I have implemented a robust authentication system that verifies users through email. Once verified, users gain access to our ticket purchase platform, where they can purchase up to 4 tickets per day. I take pride in my attention to detail, and every successful ticket purchase triggers the automatic delivery of a visually appealing ticket information PDF directly to the user's email. Additionally, this information is accessible in the user's frontend dashboard, creating a streamlined and user-friendly experience. My personal dashboard design is aesthetically pleasing and easy to navigate. Users can add buses to their favorites for convenient access and manage their account settings effortlessly. Furthermore, I have integrated Recharts for data visualization, enabling administrators to make data-driven decisions based on ticket purchase trends.Through my personal website, I aim to display not only my technical skills but also my commitment to delivering user-centric and visually appealing solutions. I believe that my proficiency in Next.js, TypeScript, and data visualization tools like Recharts make me a valuable asset to any development team. Thank you for visiting my website, and I hope you enjoy exploring my resume and portfolio. Feel free to reach out to me for any collaboration opportunities or to discuss exciting new projects!",
    tech: "Next js,Typescript, Redux, , Stripe payment,  Node js, Express js, Cloudinary image host, ,MongoDB  Mongoose.",
  },
  {
    id: 2,
    name: "jmart e-commerce",
    live: "https://jmartju.netlify.app/",
    img: image1,

    repo: "https://github.com/MuhammadJunaid01/J_mart_front_end",
    info: "The admin can launch the offer, after the offer period is over, filter out all the offers and the product whose offer date has ended will be automatically removed from the offer page and displayed on the product page. The product which will be sold more than 7 times will be filtered by the database and will be shown as the best-selling product, If a user views a product, the user can see it as his recently viewed, it is private. One user recently viewed will not be shown to other users. Users can comment on specific products, all comments read on that product will show under the product.Users can add products to the cart, delete products from the cart, and increase and decrease the quantity of products from cart.User can update their profile.Implemented pagination in the frontend.API secure using jwt.",

    tech: " React js, Redux, Redux-rtk-query, Stripe payment,  Node js, Express js, Cloudinary image host, socket. io,MongoDB  Mongoose.",
  },
  {
    id: 3,
    name: "chat App",
    live: "https://etickets-bd.vercel.app/",
    repo: "https://github.com/MuhammadJunaid01/ar-poribohon",
    img: image2,
    info: "If you want you can log in by registering in a new way, or m.junaidbkh2020@gmail.com, rana@gmail.com, mahi@gmail.com, or zahid@gmail.com, you can also log in with these emails. The password for all emails is 12345.By logging in, you can send personal messages to the user.",
    tech: "React js,Node js,Express js,socket.io ,Mongoose.",
  },
  {
    id: 4,
    name: "bike shop ",
    link: "https://mj-bike-shop.web.app/",
    img: image3,
    info: "Customers can book services, see their services, or cancel their services.Admin can approve services, manage all services, manage all bookings, add services, make admin others Customer service bookin will be confirmed after login.",
    tech: "React js,Css,,ReactBootstrap,Node js,Firebase, Heroku,Express js,MongoDb.",
  },
];
const Projects = () => {
  const [open, setOpen] = React.useState(false);
  const [project, setProject] = React.useState({});
  const handleOpen = (id) => {
    const res = projects.find((project) => project.id === id);
    setProject(res);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <div id="projects" className="project_container">
      <div className="projects_content">
        <div className="look_at_my_recent_project">
          <p>
            Look at my{" "}
            <span style={{ display: "block", marginTop: "4px" }}>
              recent projects
            </span>
          </p>
        </div>
        {/* <Carousel
          showDots={true}
          autoplay={2500}
          cols={2}
          rows={1}
          gap={5}
          loop
        >
          {projects.map((project, index) => {
            return (
              <Carousel.Item key={index}>
                <div className="project">
                  <img
                    style={{
                      width: "98%",
                      height: "330px",
                    }}
                    src={project.img}
                  />
                  <div className="projects_details">
                    <p>{project.name}</p>

                    <a href={project.link} target="_blank">
                      Live Site
                    </a>
                  </div>
                  <div className="project_info">
                    <p>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                        }}
                      >
                        About Site:
                      </span>
                      {project.info}
                    </p>

                    <p
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "16px",
                        flexDirection: "column",
                        lineHeight: "28px",
                      }}
                    >
                      <span>Technologies:</span>
                      {project.tech}
                    </p>
                  </div>
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel> */}
        <Grid container spacing={2}>
          {projects.map((project, index) => {
            return (
              <Grid key={index} item xs={12} md={3}>
                <Card sx={{ maxWidth: 345, height: 340 }}>
                  <CardMedia
                    component="img"
                    alt="green iguana"
                    height="140"
                    image={project.img}
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {project.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {project.tech}
                    </Typography>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Typography mt={1} variant="body2" color="text.secondary">
                        <span style={{ fontSize: 17, color: "black" }}>
                          Details:
                        </span>{" "}
                        {project.info.slice(0, 70)}...{" "}
                      </Typography>
                      <Tooltip
                        onClick={() => handleOpen(project.id)}
                        title="Details"
                      >
                        {/* <IconButton>
    <DeleteIcon />
  </IconButton> */}
                        <DoubleArrowIcon
                          style={{ marginTop: 29, cursor: "pointer" }}
                        />
                      </Tooltip>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </div>
      <ProjectModal open={open} handleClose={handleClose} project={project} />
    </div>
  );
};

export default Projects;
